<template>
  <div class="staff-list">
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="handleSearch">
        <!-- 一级：所属街道 -->
        <el-form-item label="所属街道">
          <el-select
              v-model="searchForm.district"
              placeholder="全部街道"
              clearable
              filterable
              style="width: 180px"
              @change="handleDistrictChange"
          >
            <el-option v-for="d in districtList" :key="d" :label="d" :value="d"></el-option>
          </el-select>
        </el-form-item>
        <!-- 二级：所属社区（联动 + 模糊搜索） -->
        <el-form-item label="所属社区">
          <el-select
              v-model="searchForm.communityId"
              placeholder="全部社区"
              clearable
              filterable
              :filter-method="filterCommunity"
              style="width: 200px"
              @clear="handleCommunityClear"
          >
            <el-option
                v-for="c in filteredCommunities"
                :key="c.id"
                :label="c.name"
                :value="c.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="success" icon="el-icon-plus" @click="openAddDialog">新增工作人员</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" v-loading="loading" stripe border>
        <el-table-column prop="id" label="ID" width="70" align="center"></el-table-column>
        <el-table-column prop="name" label="姓名" width="100"></el-table-column>
        <el-table-column prop="account" label="登录账号" width="140"></el-table-column>
        <el-table-column prop="phone" label="联系电话" width="140"></el-table-column>
        <el-table-column label="所属街道" width="130">
          <template slot-scope="{ row }">
            {{ getDistrictByCommunity(row.communityId) }}
          </template>
        </el-table-column>
        <el-table-column label="所属社区" min-width="150">
          <template slot-scope="{ row }">
            {{ getCommunityName(row.communityId) }}
          </template>
        </el-table-column>
        <el-table-column label="角色" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.role === 'admin' ? 'danger' : 'info'" size="small">
              {{ row.role === 'admin' ? '管理员' : '工作人员' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'danger'" size="small">
              {{ row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" @click="openEditDialog(row)">编辑</el-button>
            <el-button
                size="mini"
                :type="row.status === 1 ? 'warning' : 'success'"
                @click="handleToggle(row)"
            >
              {{ row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button size="mini" type="info" @click="openResetPwd(row)">重置密码</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="pagination"
      ></el-pagination>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px" @close="resetForm">
      <el-form ref="staffForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="登录账号" prop="account">
          <el-input v-model="form.account" placeholder="请输入登录账号" :disabled="!!form.id"></el-input>
        </el-form-item>

        <!-- ✅ 使用 PasswordInput 组件（新增时） -->
        <el-form-item label="密码" prop="password" v-if="!form.id">
          <password-input
              v-model="form.password"
              placeholder="请输入密码（至少8位，含大小写+数字）"
              :show-tips="true"
              :show-copy="true"
              :random-length="12"
              ref="pwdInput"
          />
        </el-form-item>

        <el-form-item label="联系电话">
          <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <!-- 弹窗内二级联动：街道 -->
        <el-form-item label="所属街道" prop="district">
          <el-select
              v-model="form.district"
              placeholder="请选择街道"
              filterable
              style="width:100%"
              @change="handleFormDistrictChange"
          >
            <el-option v-for="d in districtList" :key="d" :label="d" :value="d"></el-option>
          </el-select>
        </el-form-item>
        <!-- 弹窗内二级联动：社区 -->
        <el-form-item label="所属社区" prop="communityId">
          <el-select
              v-model="form.communityId"
              placeholder="请选择社区"
              filterable
              style="width:100%"
          >
            <el-option
                v-for="c in formFilteredCommunities"
                :key="c.id"
                :label="c.name"
                :value="c.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 重置密码弹窗 -->
    <el-dialog title="重置密码" :visible.sync="resetVisible" width="500px">
      <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="100px">
        <el-form-item label="新密码" prop="newPwd">
          <!-- ✅ 使用 PasswordInput 组件 -->
          <password-input
              v-model="pwdForm.newPwd"
              placeholder="请输入新密码"
              :show-tips="true"
              :show-copy="true"
              :random-length="12"
              ref="resetPwdInput"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="resetVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleResetPwd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStaffList,
  addStaff,
  updateStaff,
  toggleStaff,
  resetStaffPwd,
  getCommunityNameList
} from '@/api/community'

// ✅ 引入公共密码输入组件
import PasswordInput from '@/components/PasswordInput.vue'

export default {
  name: 'StaffList',

  // ✅ 注册组件
  components: {
    PasswordInput
  },

  data() {
    return {
      searchForm: { district: '', communityId: null },
      tableData: [],
      communities: [],
      districtList: [],
      filteredCommunities: [],
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '新增工作人员',
      submitting: false,
      form: {
        id: null, name: '', account: '', password: '', phone: '',
        district: '', communityId: null, role: 'worker'
      },
      rules: {
        account: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '密码至少8位', trigger: 'blur' }
        ],
        district: [{ required: true, message: '请选择街道', trigger: 'change' }],
        communityId: [{ required: true, message: '请选择社区', trigger: 'change' }]
      },
      resetVisible: false,
      pwdForm: { id: null, newPwd: '' },
      pwdRules: {
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, message: '密码至少8位', trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    formFilteredCommunities() {
      if (!this.form.district) return this.communities
      return this.communities.filter(c => c.district === this.form.district)
    }
  },

  mounted() {
    this.loadCommunities()
    this.loadData()
  },

  methods: {
    /* ========== 数据加载 ========== */
    async loadCommunities() {
      try {
        const res = await getCommunityNameList()
        const list = res.records || res.list || res.items || res || []
        this.communities = Array.isArray(list) ? list : []
        this.districtList = [...new Set(this.communities.map(c => c.district).filter(Boolean))]
        this.filteredCommunities = this.communities
      } catch (e) {}
    },

    async loadData() {
      this.loading = true
      try {
        const res = await getStaffList(this.searchForm.communityId, this.page, this.size)
        const list = res.records || res.list || res.items || res || []
        this.tableData = Array.isArray(list) ? list : []
        this.total = res.total || this.tableData.length
      } catch (e) {
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    /* ========== 搜索栏联动 ========== */
    handleDistrictChange(val) {
      this.searchForm.communityId = null
      if (!val) {
        this.filteredCommunities = this.communities
      } else {
        this.filteredCommunities = this.communities.filter(c => c.district === val)
      }
    },

    handleCommunityClear() {
      this.searchForm.communityId = null
    },

    filterCommunity(query) {
      if (!query) return
      const q = query.toLowerCase().trim()
      const source = this.searchForm.district
          ? this.communities.filter(c => c.district === this.searchForm.district)
          : this.communities
      this.filteredCommunities = source.filter(c =>
          c.name.toLowerCase().includes(q)
      )
    },

    /* ========== 弹窗内联动 ========== */
    handleFormDistrictChange() {
      this.form.communityId = null
    },

    /* ========== 搜索 / 重置 ========== */
    handleSearch() { this.page = 1; this.loadData() },

    resetSearch() {
      this.searchForm = { district: '', communityId: null }
      this.filteredCommunities = this.communities
      this.page = 1
      this.loadData()
    },

    handleSizeChange(val) { this.size = val; this.loadData() },
    handleCurrentChange(val) { this.page = val; this.loadData() },

    /* ========== 工具方法 ========== */
    getCommunityName(id) {
      const c = this.communities.find(x => x.id === id)
      return c ? c.name : '-'
    },

    getDistrictByCommunity(id) {
      const c = this.communities.find(x => x.id === id)
      return c ? c.district : '-'
    },

    /* ========== 弹窗操作 ========== */
    openAddDialog() {
      this.dialogTitle = '新增工作人员'
      this.form = {
        id: null, name: '', account: '', password: '', phone: '',
        district: '', communityId: null, role: 'worker'
      }
      this.dialogVisible = true
    },

    openEditDialog(row) {
      this.dialogTitle = '编辑工作人员'
      const com = this.communities.find(x => x.id === row.communityId)
      this.form = {
        ...row,
        password: '',
        district: com ? com.district : ''
      }
      this.dialogVisible = true
    },

    resetForm() {
      this.$refs.staffForm && this.$refs.staffForm.resetFields()
    },

    handleSubmit() {
      this.$refs.staffForm.validate(async valid => {
        if (!valid) return

        // ✅ 校验密码强度（新增时）
        if (!this.form.id) {
          const pwdComp = this.$refs.pwdInput
          if (pwdComp && !pwdComp.isValid(2)) {
            this.$message.warning('密码强度不足，请包含大小写字母和数字')
            return
          }
        }

        this.submitting = true
        try {
          if (this.form.id) {
            await updateStaff(this.form)
          } else {
            await addStaff(this.form)
          }
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.loadData()
        } catch (e) {} finally {
          this.submitting = false
        }
      })
    },

    async handleToggle(row) {
      try {
        await toggleStaff(row.id)
        this.$message.success(row.status === 1 ? '已禁用' : '已启用')
        this.loadData()
      } catch (e) {}
    },

    openResetPwd(row) {
      this.pwdForm = { id: row.id, newPwd: '' }
      this.resetVisible = true
    },

    handleResetPwd() {
      this.$refs.pwdForm.validate(async valid => {
        if (!valid) return

        // ✅ 校验密码强度
        const pwdComp = this.$refs.resetPwdInput
        if (pwdComp && !pwdComp.isValid(2)) {
          this.$message.warning('密码强度不足，请包含大小写字母和数字')
          return
        }

        this.submitting = true
        try {
          await resetStaffPwd(this.pwdForm.id, this.pwdForm.newPwd)
          this.$message.success('密码重置成功')
          this.resetVisible = false
        } catch (e) {} finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.staff-list { padding: 0; }
.search-card { margin-bottom: 16px; border-radius: 8px; }
.table-card { border-radius: 8px; }
.pagination { margin-top: 16px; text-align: right; }
</style>
